function createCustomError(message, name) {
    const customError = new Error(message);
    customError.name = name;
    return customError;
}

function throwCustomError(message, name) {
    const customError = createCustomError(message, name);
    throw customError;
}

export {
    createCustomError,
    throwCustomError
}
